import React, { FC, useEffect, useRef, useState } from 'react';

import { StrictWidthContainer } from '~/views/components/strictWidthText/styles';

type Props = {
    text: string;
    width?: string;
};

const StrictWidthText: FC<Props> = ({ text, width }) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState<boolean>(false);

    useEffect(() => {
        const checkTruncation = () => {
            const element = textRef.current;

            if (element) {
                // If the scrollWidth of the element is greater than the clientWidth then we know that the text
                // is truncated
                setIsTruncated(element.scrollWidth > element.clientWidth);
            }
        };

        checkTruncation();

        window.addEventListener('resize', checkTruncation);

        return () => {
            window.removeEventListener('resize', checkTruncation);
        };
    }, [text]);

    return (
        <StrictWidthContainer ref={textRef} $width={width} title={isTruncated ? text : undefined}>
            {text}
        </StrictWidthContainer>
    );
};

export default StrictWidthText;
